export default {
  mounted() {
    console.group('OnboardingAnalytics Hook Mounted');
    
    try {
      // Get the user ID from the data attribute
      const userId = this.el.dataset.userId;
      
      // Ensure dataLayer exists
      if (!window.dataLayer) {
        console.log('Initializing window.dataLayer');
        window.dataLayer = [];
      }
      
      // Handle direct push_to_datalayer events
      this.handleEvent("google_tag_manager", ( event ) => {
        try {
          console.log('Received push_to_datalayer event:', event.event_name);
          
          // Ensure dataLayer exists before pushing
          if (!window.dataLayer) {
            console.log('Re-initializing window.dataLayer before push');
            window.dataLayer = [];
          }
          
          // Use the event as-is, only add user_id if not present
          const formattedEvent = {
            ...event,
            user_id: event.user_id || userId
          };
          
          window.dataLayer.push(formattedEvent);
          console.log('Successfully pushed event to dataLayer:', formattedEvent);
          
          // Debug logging if enabled
          if (window.dataLayerDebug) {
            window.dataLayerDebug(formattedEvent);
          }
        } catch (error) {
          console.error('Error handling push_to_datalayer event:', error);
          console.error('Event that caused error:', event);
        }
      });
    } catch (error) {
      console.error('Error in OnboardingAnalytics hook mounted:', error);
    }

    console.groupEnd();
  },

  updated() {
    try {
      if (!window.dataLayer) {
        console.log('dataLayer is not initialized in updated hook');
      }
    } catch (error) {
      console.error('Error in OnboardingAnalytics hook updated:', error);
    }
  },

  destroyed() {
    console.log('OnboardingAnalytics hook destroyed');
  }
} 